import { TYPES } from "./report.type";
import moment from "moment";

const initState = {
  company: null,
  from: moment().startOf("week"),
  to: moment().endOf("week"),
  edit: false,
  user: "",
  reportData: null,
  totalWorking: null,
  totalBreaking: null,
  range: null,
  //
  photos: false,
  location: false,
  //dialog
  open: false,
  dialogUser: "",
  dialogDate: null,
  dialogTime: null,
};

const reportReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TYPES.SELECT_COMPANY_NAME:
      return {
        ...state,
        company: payload,
      };

    case TYPES.SELECT_TIME_FROM:
      return {
        ...state,
        from: payload,
      };

    case TYPES.SELECT_TIME_TO:
      return {
        ...state,
        to: payload,
      };

    case TYPES.SELECT_EDITABLE:
      return {
        ...state,
        edit: payload,
      };

    case TYPES.SELECT_USER:
      return {
        ...state,
        user: payload,
      };

    // -----
    case TYPES.SELECT_REPORT_DATA:
      return {
        ...state,
        reportData: payload,
      };

    case TYPES.SELECT_TOTAL_WORKING:
      return {
        ...state,
        totalWorking: payload,
      };

    case TYPES.SELECT_TOTAL_BREAKING:
      return {
        ...state,
        totalBreaking: payload,
      };

    case TYPES.SELECT_RANGE:
      return {
        ...state,
        range: payload,
      };

    case TYPES.SELECT_PHOTOS:
      return {
        ...state,
        photos: payload,
      };

    case TYPES.SELECT_LOCATION:
      return {
        ...state,
        location: payload,
      };

    case TYPES.SELECT_OPEN:
      return {
        ...state,
        open: payload,
      };

    default:
      return state;
  }
};

export default reportReducer;
